import { render, staticRenderFns } from "./refuseHandle.vue?vue&type=template&id=1348751c&"
import script from "./refuseHandle.vue?vue&type=script&lang=js&"
export * from "./refuseHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "refuseHandle.vue"
export default component.exports